// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fn-wrap[data-v-249d611e]{height:100%;display:-webkit-box;display:-webkit-flex;display:flex;align-items:center;padding-right:.38647rem;margin-right:.38647rem;border-right:.02415rem solid #ebebeb}", ""]);
// Exports
module.exports = exports;
